import { useState, createContext, useContext } from 'react';
import jwt_decode from 'jwt-decode';
const AuthContext = createContext(null);

export const AuthProvider = ({ children, role }) => {
  const [user, setUser] = useState(null);
  const login = (userLogin) => {
    setUser(userLogin);
    sessionStorage.setItem('user', userLogin);
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('user');
  };

  const decoder = (token) => {
    return {
      data: jwt_decode(token),
      token: token,
    };
  };

  const setUserFromToken = (token) => {
    const decoded = jwt_decode(token);
    const userLogin = {
      token,
      data: decoded,
    };
    login(userLogin.token); // sets state + sessionStorage
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, decoder, setUserFromToken }}>
      {' '}
      {/* , menuAccess, setMenuAccess */}
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
